import script from "./TextAlbum.vue?vue&type=script&lang=ts&setup=true"
export * from "./TextAlbum.vue?vue&type=script&lang=ts&setup=true"

import "./TextAlbum.vue?vue&type=style&index=0&id=6c0a963c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c0a963c"]])

export default __exports__